import React from 'react';

export const Activities = () => {
  const activities = [
    {
      id: 1,
      name: "Música e Movimento",
      description: "Desenvolvimento da expressão corporal e sensibilidade musical",
      image: "https://images.pexels.com/photos/8422173/pexels-photo-8422173.jpeg"
    },
    {
      id: 2,
      name: "Artes e Criatividade",
      description: "Estímulo à criatividade através de atividades artísticas variadas",
      image: "https://images.unsplash.com/photo-1560130958-0ea787c275de"
    },
    {
      id: 3,
      name: "Atividades ao Ar Livre",
      description: "Contato com a natureza e brincadeiras que estimulam o desenvolvimento motor",
      image: "https://images.unsplash.com/photo-1606092195730-5d7b9af1efc5"
    }
  ];

  return (
    <section id="activities" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block mb-4">
            <span className="text-amber-600 font-semibold text-sm uppercase tracking-wider bg-amber-100 px-4 py-2 rounded-full">
              Nossas Atividades
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            Aprender Brincando
          </h2>
          <p className="text-lg text-gray-600">
            Atividades lúdicas e educativas que estimulam o desenvolvimento integral da criança
          </p>
        </div>

        {/* Activities Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {activities.map((activity) => (
            <div 
              key={activity.id}
              className="group relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
            >
              {/* Image with Overlay */}
              <div className="relative h-80 overflow-hidden">
                <img
                  src={activity.image}
                  alt={activity.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/50 to-transparent opacity-80 group-hover:opacity-90 transition-opacity"></div>
                
                {/* Number Badge */}
                <div className="absolute top-6 right-6 w-14 h-14 bg-amber-500 rounded-full flex items-center justify-center shadow-xl group-hover:scale-110 transition-transform">
                  <span className="text-white font-bold text-xl">0{activity.id}</span>
                </div>
              </div>

              {/* Content Overlay */}
              <div className="absolute bottom-0 left-0 right-0 p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform">
                <h3 className="text-2xl font-bold text-white mb-3">
                  {activity.name}
                </h3>
                <p className="text-gray-200 leading-relaxed opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                  {activity.description}
                </p>
              </div>

              {/* Decorative Corner */}
              <div className="absolute top-0 left-0 w-20 h-20 bg-amber-400 opacity-20 rounded-br-full transform -translate-x-10 -translate-y-10 group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
